import React, { useEffect, useState } from 'react'

// bootstrap
import {
    Table,
    OverlayTrigger,
    Image,
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router
import { Link } from 'react-router-dom';

// skeleton loading
import ProductsLodingSkeleton from './table__loadingSkeleton'

// tooltips
import { renderTooltipDelete, renderTooltipEdit } from '../tooltips/Table__Tooltips'

// images
import noImgFound from 'assets/images/no-img-found.png'

// helpers
import { generateReactRouterUrl } from 'utlis/helpers/Common/CommonHelperFunctions';

export default function ProductsTable(props) {
    // props
    const { parentProps, handleProductStatusChange, productsImages } = props

    // states
    const [currentUrl, setCurrentUrl] = useState("")

    const getOptions = data => {
        // console.log("data ", JSON.parse());

        return "5"
    }

    const getVariations = data => {
        return "12"
    }

    // generating current url
    useEffect(() => {
        const location = parentProps.location
        if (location) {
            const url = generateReactRouterUrl(location)
            setCurrentUrl(url)
        }
    }, [parentProps])

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    <th width={35}>
                        <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                            <input
                                type="checkbox"
                                className="d-none"
                                checked={props.allCheckboxSelected}
                                onChange={ev => props.handleSelectAllChange(ev)} />
                            <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                <FeatherIcon
                                    icon="check"
                                    size="11"
                                    className="icon position-relative" />
                            </span>
                        </label>
                    </th>

                    {
                        props.column__ProductImg && (
                            <th width={100}>
                                <p className="text-capitalize">
                                    image
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__ProductName && (
                            <th>
                                <p className="text-capitalize">
                                    name
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__ProductSKU && (
                            <th>
                                <p className="text-capitalize">
                                    SKU
                                </p>
                            </th>
                        )
                    }

                    {/* {
                        props.column__ProductStatus && (
                            <th>
                                <p className="text-capitalize">
                                    Status
                                </p>
                            </th>
                        )
                    } */}

                    {
                        props.column__ProductStock && (
                            <th>
                                <p className="text-capitalize">
                                    Stock
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__ProductPrice && (
                            <th>
                                <p className="text-capitalize">
                                    Price
                                </p>
                            </th>
                        )
                    }

                    <th width="90"></th>
                </tr>
            </thead>

            <tbody>
                {
                    /* loading */
                    props.loading && (
                        <React.Fragment>
                            {
                                (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <ProductsLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    )
                }

                {
                    /* EMAILS DATA */
                    (props.products && props.products.length) ? props.products.map(item => (
                        <tr key={item.product_id}
                            data-status={!item.active ? "disabled" : "enabled"}
                            className={`${!item.active ? "status_disabled" : "status_enabled"}`}
                        >
                            <td className="column__checkbox">
                                <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                    <input type="checkbox" className="d-none all-checkboxes-selector-checkbox" />
                                    <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                        <FeatherIcon
                                            icon="check"
                                            size="11"
                                            className="icon position-relative" />
                                    </span>
                                </label>
                            </td>

                            {
                                // props.column__ProductImg && (
                                //     <td className="column__ProductImg">
                                //         <p className="">
                                //             <Image src={item.thumb ? item.thumb : noImgFound} fluid width={70} />
                                //         </p>
                                //     </td>
                                // )
                                props.column__ProductImg && (
                                    <td className="column__ProductImg">
                                        <p className="">
                                            <Image src={productsImages[item.product_id]?.main_thumb?.small ?? noImgFound} fluid width={70} />
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__ProductName && (
                                    <td className="column__ProductName">
                                        {/* name */}
                                        <Link
                                            to={{
                                                pathname: '/catalog/products/edit/' + item.product_id,
                                                state: { productDetails: item, from: currentUrl }
                                            }}
                                            className="text-decoration-none hover-underline-link st-text-primary">
                                            {item.product_name}
                                        </Link>

                                        {/* variant details */}
                                        <p className="variations d-flex align-items-center">
                                            <FeatherIcon
                                                icon="copy"
                                                size="12"
                                                className="icon me-2"
                                            />
                                            <span className="me-2">
                                                {item?.combinations && getOptions(item.combinations) + " Options"}
                                            </span>
                                            <span className="">
                                                {item?.variations && getVariations(item.variations) + " Variations"}
                                            </span>
                                        </p>

                                        {/* toggle to enable / disable */}
                                        <label className="st-switch-input-xs st-switch-success d-inline-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="d-none"
                                                checked={(item.active === 1) ? true : false}
                                                onChange={ev => handleProductStatusChange(ev, item.product_id)}
                                            />

                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>

                                            <span className="text ms-2 position-relative st-fs-12 st-fw-600">
                                                {
                                                    (item.active === 1) ? "Enabled" : "Disabled"
                                                }
                                            </span>
                                        </label>
                                    </td>
                                )
                            }

                            {
                                props.column__ProductSKU && (
                                    <td className="column__ProductSKU">
                                        <p className="">
                                            {item.sku}
                                        </p>
                                    </td>
                                )
                            }

                            {/* {
                                props.column__ProductStatus && (
                                    <td className="column__ProductStatus">
                                        <p className="">
                                            {item.active ? "Active" : "Inactive"}
                                        </p>
                                    </td>
                                )
                            } */}

                            {
                                props.column__ProductStock && (
                                    <td className="column__ProductStock">
                                        <p className="">
                                            {item.stock}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__ProductPrice && (
                                    <td className="column__ProductPrice">
                                        <p className="">
                                            ${item.price}
                                        </p>
                                    </td>
                                )
                            }

                            <td className="column__actions">
                                <div className="d-flex justify-content-end">
                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipEdit}
                                    >
                                        <Link
                                            to={{
                                                pathname: '/catalog/products/edit/' + item.product_id,
                                                state: { productDetails: item, from: currentUrl }
                                            }}
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                        >
                                            <FeatherIcon
                                                icon="edit-2"
                                                size="15"
                                                className="icon" />
                                        </Link>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipDelete}
                                    >
                                        <button
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                            onClick={ev => props.handleDelete(ev, item.product_id)}
                                        >
                                            <FeatherIcon
                                                icon="trash"
                                                size="15"
                                                className="icon" />
                                        </button>
                                    </OverlayTrigger>
                                </div>
                            </td>
                        </tr>
                    )) : (
                        !props.loading ? (
                            <tr>
                                <td colSpan="7">
                                    <p className="no-data-found text-center st-fw-700 py-1">
                                        no data found
                                    </p>
                                </td>
                            </tr>
                        ) : null
                    )
                }
            </tbody>
        </Table>
    )
}
